export default __webpack_public_path__ + "static/media/minus.c9847cfc.svg";